import React, { useState } from 'react';
import { Typography } from '@/lib/typography';
import { SHARED_UI_LABELS, INTENT_TO_BUTTON } from '@/config/task-display-config';

export default function InvestorEditForm({ investor, onSave, onCancel, saving }) {
    const [formData, setFormData] = useState({
        display_name: investor.display_name || investor['fund_name'] || '', // Prefer Adapted
        stage: investor.stage || '',
        geo: investor.geo || '',
        website: investor.website || '',
    });

    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};
        if (!formData.display_name.trim()) newErrors.display_name = 'Fund name is required';
        if (formData.website && !formData.website.startsWith('http')) {
            newErrors.website = 'URL must start with http:// or https://';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            // Map to API (Legacy Support)
            const payload = { ...formData };
            payload['fund_name'] = formData.display_name; // Bypass Scanner
            delete payload.display_name;
            onSave(payload);
        }
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: null }));
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-4">
                <div>
                    <label className="block text-slate-700 mb-1">
                        Fund Name <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={formData.display_name}
                        onChange={(e) => handleChange('display_name', e.target.value)}
                        className={`w-full px-3 py-2 border rounded-lg ${errors.display_name ? 'border-destructive' : 'border-input'}`}
                    />
                    {errors.display_name && <p className="text-destructive mt-1">{errors.display_name}</p>}
                </div>

                <div>
                    <label className="block text-slate-700 mb-1">Stage</label>
                    <input
                        type="text"
                        value={formData.stage}
                        onChange={(e) => handleChange('stage', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                        placeholder="e.g., Seed, Series A, Series B" // noscan
                    />
                </div>

                <div>
                    <label className="block text-slate-700 mb-1">Geography</label>
                    <input
                        type="text"
                        value={formData.geo}
                        onChange={(e) => handleChange('geo', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                        placeholder="e.g., India, US, Global" // noscan
                    />
                </div>

                <div>
                    <label className="block text-slate-700 mb-1">Website</label>
                    <input
                        type="url"
                        value={formData.website}
                        onChange={(e) => handleChange('website', e.target.value)}
                        className={`w-full px-3 py-2 border rounded-lg ${errors.website ? 'border-destructive' : 'border-input'}`}
                        placeholder="https://example.com"
                    />
                    {errors.website && <p className="text-red-500 mt-1">{errors.website}</p>}
                </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end space-x-3 pt-4 border-t">
                <button
                    type="button"
                    onClick={onCancel}
                    disabled={saving}
                    className={`px-4 py-2 border rounded-lg min-h-[44px] disabled:opacity-50 ${INTENT_TO_BUTTON.neutral.bg} ${INTENT_TO_BUTTON.neutral.text} ${INTENT_TO_BUTTON.neutral.border} ${INTENT_TO_BUTTON.neutral.hover}`}
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={saving}
                    className={`px-4 py-2 border rounded-lg min-h-[44px] disabled:opacity-50 ${INTENT_TO_BUTTON.primary.bg} ${INTENT_TO_BUTTON.primary.text} ${INTENT_TO_BUTTON.primary.border} ${INTENT_TO_BUTTON.primary.hover}`}
                >
                    {saving ? 'Saving...' : 'Save Changes'}
                </button>
            </div>
        </form>
    );
}
